export const HANGOUT_EVENTS = {
  SESSION_STARTED: 'hangout:session:started',
  SESSION_ENDED: 'hangout:session:ended',
  MESSAGE_SENT: 'hangout:message:sent',
  MESSAGE_RECEIVED: 'hangout:message:received',
  SPOT_SELECTED: 'hangout:location:selected',
  STATE_CHANGED: 'hangout:state:changed',
  CHARACTER_SELECTED: 'hangout:character:selected',
  OUTFIT_SELECTED: 'hangout:outfit:selected',
  BACKGROUND_CHANGED: 'hangout:background:changed',
  TIME_OF_DAY_CHANGED: 'hangout:time:changed',
  CONVERSATION_RESUMED: 'hangout:conversation:resumed'
};

export const STORAGE_KEYS = {
  HISTORY: 'hangout:history',
  OPENING_GREETING: 'hangout:openingGreeting',
  CUSTOM_SCENARIO_DESCRIPTION: 'hangout:customScenarioDescription',
  HISTORY_SCHEMA_VERSION: 'hangout:historySchemaVersion'
};

export const STORAGE_PREFIXES = {
  HANGOUT_TIME: 'hangout_time_'
};

export const CONFIG_KEY = 'currentHangoutConfig';

export const ERROR_VALUES = {
  MISSING_LOCATION: 'ERROR_NO_LOCATION',
  MISSING_TIME: 'ERROR_NO_TIME',
  MISSING_BACKGROUND: 'ERROR_NO_BACKGROUND',
  MISSING_CHARACTER: 'ERROR_NO_CHARACTER'
};

export const ACTIVE_VERSIONS_STORAGE_KEY = 'hangout:activeVersions:v2';
